import { render, staticRenderFns } from "./questionBankManage.vue?vue&type=template&id=2e951248&scoped=true"
import script from "./questionBankManage.vue?vue&type=script&lang=js"
export * from "./questionBankManage.vue?vue&type=script&lang=js"
import style0 from "./questionBankManage.vue?vue&type=style&index=0&id=2e951248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e951248",
  null
  
)

export default component.exports